import logo from './logo.svg';
import './App.css';
import * as React from "react";
/*import { default as igigiQA } from "./data/igigi-quest.js";
import { default as kyrpaQA } from "./data/kyrpa-quest.js";
import { default as igigiCtx } from "./data/igigi-quest-context.js";
import { default as kyrpaCtx } from "./data/kyrpa-quest-context.js";
import { default as igigiScraped } from "./data/igigi-quest-scraped.js";
import { default as kyrpaScraped } from "./data/kyrpa-quest-scraped.js";*/
import Fuse from "fuse.js";
import axios from "axios";

function App() {
  const [thread, setThread] = React.useState('kyrpa-quest');
  const [ctx, setCtx] = React.useState({});
  const [result, setResult] = React.useState([]);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [answer, setAnswer] = React.useState("");
  const [qa, setQA] = React.useState({});

  React.useEffect(() => {
    const getContext = () => {
      getThreadContext(thread).then((context) =>  {
        setCtx(context);
      });
    }

    return getContext();
  }, [thread]);

  const getThreadContext = async (thread) => {

    var qa, scraped, context;
    const URL = "https://sigma-nation-thundersplace-gpt-api.vercel.app";

    try {
      let { data } = await axios.get(URL + "/thread/" + thread + "/questions");
      qa = data;
    } catch (e) {
      console.log(e);
      return {};
    }

    try {
      let { data } = await axios.get(URL + "/thread/" + thread + "/scraped");
      scraped = data;
    } catch (e) {
      console.log(e);
      return {};
    }

    try {
      let { data } = await axios.get(URL + "/thread/" + thread + "/context");
      context = data;
    } catch (e) {
      console.log(e);
      return {};
    }

    return {
      qa,
      scraped, 
      context
    };
  }

  const goToPost = (pageNumber) => {
    let link = ctx["scraped"]["link"];
    link = link.replace(/pageNumber/g, pageNumber);
    window.open(link);
    // replace substring 'pageNumber' in link
  }

  const clickQuestion = (q) => {
    const { question, pageNumber, answer, id } = q;
    setModalOpen(true);
    setQA({
      question,
      answer,
      id,
      pageNumber
    });
  }

  const handleModalClose = () => {
    setModalOpen(false);
  }

  const fuzzySearch = (e) => {
    var query = e.currentTarget.value;
    const options = {
      includeScore: true,
      keys: ['question']
    };

    const fuse = new Fuse(ctx["qa"] || [], options)

    const _result = fuse.search(query);
    setResult(_result);
  }

  const changeThread = (thread) => {
    setThread(thread);
  }

  return (
    <div className="App">
      <div className="">
        <div className="App-header">
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Thundersplace Thread Question Search
          </a>
          <div className="select-thread">
            <span>Select thread:</span>
            <select onChange={(e) => changeThread(e.currentTarget.value)}>
              <option value="kyrpa-quest">Kyrpa Quest</option>
              <option value="igigi-quest">Igigi Quest</option>
            </select>
          </div>
          <div className="search-container">
            <input onChange={fuzzySearch}></input>
            <div className="search-result-container">
              <div className="search-result">
                { result && result.map((q => {
                  return <a href="#" onClick={() => clickQuestion(q["item"])}><p>{q["item"]["question"]}</p></a>
                }))}
              </div>
            </div>
          </div>
        </div>
      </div>
      { modalOpen && (
        <div className="modal">
          <div className="modal-content">
            <button className="close-button" onClick={handleModalClose}>
              X
            </button>
            <div className="modal-text">
              <p>{qa["answer"]}</p>
            </div>
            <div className="modal-buttons">
              <button onClick={() => goToPost(qa["pageNumber"])}>go to post</button>
            </div>
          </div>
        </div>
      )
      }
    </div>
  );
}

export default App;
